module.exports = __webpack_public_path__ + "static/media/Kirsten Coeur.50ed5166.png";